/* eslint-disable no-use-before-define */
/* eslint-disable no-undef */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-multi-assign */

import { InitFlowStatusTracker } from './InitFlowStatusTracker';
import { omtServicesInit } from './Services/OMT/OMT_Init';
import { LevelEditor } from './Editor/LevelEditor/LevelEditor';
import { MapEditor } from './Editor/MapEditor/MapEditor';
import { Boot } from './States/Boot';
//import { ErrorHandlerOptions, SDKWrapper } from "./Utils/SDKWrapper";
import { Preloader } from './States/Preloader';
import { IncompatibleWarning } from './States/IncompatibleWarning';
import Game from './States/Game';

/**
 * class for intializing the game / Phaser
 */
class GameLauncher {
  /**
  * first initialization of game systems
  */
  async init() {
    // merge OMTSettings files
    G.featureUnlock = _.merge(G.featureUnlockDefault, G.featureUnlock);
    G.OMTsettings = _.merge(G.OMTsettingsDefault, G.OMTsettings);
    G.Debug.registerOutOfMemoryOnBitmapsReporter();
    G.sb = G.SignalBox;

    this._decompressLevelData();
    await omtServicesInit();
    this._startGame(); // game loading will begin while remaining services initialize

    try { // attempt to connect to game-backend
      // await OMT.connect.init();
    } catch (error) {
      console.warn('Could not connect to game-backend.');
    }

    // flag OMT services started
    InitFlowStatusTracker.getInstance().setOMTServicesStarted();

    if (!G.BuildEnvironment.production) G.Debug.Stats.show();
  }

  /**
   * decompress the level data asyncronously. This is required befor the gameplay starts.
   */
  _decompressLevelData() {
    const decompressStartTime = Date.now();
    LZUTF8.decompressAsync(unescape(G.json.levels), { inputEncoding: 'Base64', outputEncoding: 'String' }, (output) => {
      G.json.levels = JSON.parse(output);
      InitFlowStatusTracker.getInstance().setLevelDataReady(); // flag level data ready
      const decompressTime = (Date.now() - decompressStartTime);
      console.log(`LevelDataUnpacked in ${decompressTime} ms`);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.LevelDataUnpacked, decompressTime);
    });
  }

  /**
   * start phaser and set the game states
   */
  _startGame() {
    const game = window.game = new Phaser.Game(100, 100, Phaser.CANVAS, '', null, false);
    game.state.onStateChange.add(() => {
      game.input.interactiveItems.removeAll();
    });

    game.state.add('Boot', Boot);
    game.state.add('Preloader', Preloader);
    game.state.add('World', G.World);
    game.state.add('Game', Game);
    game.state.add('IncompatibleWarning', IncompatibleWarning);

    // Dev/test/debug
    game.state.add('Editor', LevelEditor);
    game.state.add('EditorWorld', MapEditor);

    // Now start the Boot state.
    game.state.start('Boot');

    // bodge for 0% error, need to investigate more
    setTimeout(() => {
      if (game.state._pendingState === 'Boot' && game.paused) {
        game.paused = false;
      }
    }, 2000);
  }
}

// set global reference
const gameLauncher = new GameLauncher();
window.initGame = () => { gameLauncher.init(); };
